import { render, staticRenderFns } from "./HealthierTogetherTab.vue?vue&type=template&id=f7cd72c4&scoped=true"
import script from "./HealthierTogetherTab.vue?vue&type=script&lang=js"
export * from "./HealthierTogetherTab.vue?vue&type=script&lang=js"
import style0 from "./HealthierTogetherTab.vue?vue&type=style&index=0&id=f7cd72c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7cd72c4",
  null
  
)

export default component.exports